export const enumWalletProductGroupId = {
    TOTAL: { ID: 0, piwikName: "Total" },
    MAIN: { ID: 1, piwikName: "Main" },
    SB: { ID: 2, piwikName: "Sports/Esports" }, // 体育 / 电竞
    LD: { ID: 4, piwikName: "Live Dealer" }, // 真人
    P2P: { ID: 24, piwikName: "P2P/InstantGames/Fishing" }, // 棋牌 / 小游戏
    SLOT: { ID: 32, piwikName: "Slots" }, // 游戏
    KENO: { ID: 64, piwikName: "Lottery" }, // 彩票
};
